"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalConfirmKey = void 0;
var ModalConfirmKey;
(function (ModalConfirmKey) {
    ModalConfirmKey["FixInnerConsistency"] = "fixInnerConsistency";
    ModalConfirmKey["FixLinkConsistency"] = "fixLinkConsistency";
})(ModalConfirmKey = exports.ModalConfirmKey || (exports.ModalConfirmKey = {}));
//# sourceMappingURL=apphook.js.map